import { Action, Dispatch } from 'redux';
import { PayloadAction } from 'sos-common/js/commonTypes/action.types';
import { ResourceItem } from 'sos-common/js/commonTypes/resourceItem';
import { WizardHostStat } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { doValidate } from './validationResults.action';

export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';
export type setTranslationAction = PayloadAction<typeof SET_TRANSLATIONS, ResourceItem[]>;

export function setTranslation(translations: ResourceItem[]) {
  return {
    type: SET_TRANSLATIONS,
    payload: translations,
  } as setTranslationAction;
}

export const CLOSE_MESSAGE_BAR = 'CLOSE_MESSAGE_BAR';
export type closeMessageBarAction = Action<typeof CLOSE_MESSAGE_BAR>;
export function closeMessageBar() {
  return {
    type: CLOSE_MESSAGE_BAR,
  } as closeMessageBarAction;
}

export const SET_FORM_ID = 'SET_FORM_ID';
export type setFormOrderIdAction = PayloadAction<typeof SET_FORM_ID, string>;
export function setFormId(formId: string) {
  return {
    type: SET_FORM_ID,
    payload: formId,
  } as setFormOrderIdAction;
}

export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export type setCurrentStepAction = PayloadAction<typeof SET_CURRENT_STEP, WizardHostStat>;
export function setCurrentStep(step: WizardHostStat) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: SET_CURRENT_STEP,
      payload: step,
    } as setCurrentStepAction);
    dispatch(doValidate());
  };
}

export const SET_IS_SAVING = 'SET_IS_SAVING';
export type setIsSavingAction = PayloadAction<typeof SET_IS_SAVING, boolean>;

export function setSavingState(isSaving: boolean): setIsSavingAction {
  return {
    type: SET_IS_SAVING,
    payload: isSaving,
  };
}

export type globalActions =
  | setTranslationAction
  | setFormOrderIdAction
  | closeMessageBarAction
  | setCurrentStepAction
  | setIsSavingAction;
